// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"FlipsContainer_linkContainer__2URx6","headingClass":"FlipsContainer_headingClass__z57OY"};